export const attributionNavState = {
  skipNextForceFetch: false,
};
